import { http } from '../http';

export async function sendOnboardingOtp(onboardingUlid: string) {
	const resendOtpResponse = await http.post<Record<string, unknown>>(
		`v2/onboarding/${onboardingUlid}/phone/send-otp`,
		null,
	);
	if (resendOtpResponse) {
		return resendOtpResponse;
	} else {
		throw new Error('Resend OTP failed');
	}
}
